import { useTranslation } from "react-i18next";

import FullPageMessage from "../../../components/FullPageMessage";

function AcceptanceEmailConfirmationPage() {
  const LocalBasePath = "page.signUpSuccessfully";
  const { t } = useTranslation("", {
    keyPrefix: LocalBasePath,
  });
  return (
    <FullPageMessage
      body={t("acceptanceLearnerMessage")}
      title={t("sendInfoDone")}
    />
  );
}
export default AcceptanceEmailConfirmationPage;
